import { useState } from "react";
import styles from "./Footer.module.css";
import VersionInfoModal from "../VersionInfoModal/VersionInfoModal";
import SubmitBugModal from "../Modals/SubmitBugModal";
import { ReactComponent as VersionIcon } from '../../assets/version.svg';

export default function Footer ({ user }) {
  const [isModalOpen, setModalOpen] = useState(false);
  const [isBugModalOpen, setBugModalOpen] = useState(false);
  return (
    <footer className={styles.footer}>
      <div className={styles.footer_inner}>
        <p>© {new Date().getFullYear()} Movie Friends</p>
        <button className={styles.text_button} onClick={() => setBugModalOpen(true)}>Report Bug</button><br></br>
        <button className={styles.text_button} onClick={() => setModalOpen(true)}><span><VersionIcon className="btnIcon"/>Version</span></button>
        <VersionInfoModal isOpen={isModalOpen} onClose={() => setModalOpen(false)}/>
        <SubmitBugModal isOpen={isBugModalOpen} onClose={() => setBugModalOpen(false)} user={user}/>
        <p>Built with ❤️ by Shpoopdy</p>
      </div>
    </footer>
  )
}
